import { render } from "./PageForms.vue?vue&type=template&id=f9b32caa"
import script from "./PageForms.vue?vue&type=script&lang=js"
export * from "./PageForms.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__